module.exports = __webpack_public_path__ + "media/application/images/icons/search-1fb13e98a4e3b841c1a3670cb6c75ee6.svg";